import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-quill-textarea',
  templateUrl: './quill-textarea.component.html',
  styleUrls: ['./quill-textarea.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => QuillTextareaComponent),
      multi: true
    }
  ],
  standalone: false
})
export class QuillTextareaComponent implements ControlValueAccessor {

  @Input() value: string = '';
  @Output() valueChange: EventEmitter<string> = new EventEmitter();

  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() type?: string;
  @Input() size?: string;

  @Input() formControlName?: string;
  @Input() control!: FormControl;

  @Input() showActionButton: boolean = false;
  @Input() actionButtonText?: string;
  @Input() actionIcon: string = '';
  @Output() actionButtonClicked: EventEmitter<any> = new EventEmitter<any>();

  private onChange = (value: any) => {};
  private onTouched = () => {};

  isFocused: boolean = false;

  // Configuration for the Quill editor toolbar
  editorModules = {
    toolbar: [
      ['bold', 'underline'], // Text formatting
      [{ script: 'sub' }, { script: 'super' }],
      [{ list: 'ordered' }, { list: 'bullet' }], // Lists
      // ['image'], // Media
    ],
    keyboard: {
      bindings: {
        tab: {
          key: 'Tab',
          handler: () => true,
        },
      },
    },
  };

  constructor() {}

  ngOnInit() {
  }

  writeValue(value: any): void {
    if (this.control && value !== this.control.value) {
      this.control.setValue(value, { emitEvent: false });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.control.valueChanges.subscribe(value => {
      this.valueChange.emit(value);
    });
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }

  handleFocus() {
    this.isFocused = true;
    this.onTouched();
  }

  handleBlur() {
    this.isFocused = false;
  }

  handleActionClick() {
    this.actionButtonClicked.emit();
  }
}
